"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceRoot = exports.OldPrice = exports.CurrentPrice = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const PriceRoot = exports.PriceRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1)
}));
const CurrentPrice = exports.CurrentPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isOffer'])
})(({
  isOffer,
  theme
}) => ({
  color: isOffer ? theme.palette.offer.dark : undefined,
  fontWeight: theme.typography.fontWeightBold
}));
const OldPrice = exports.OldPrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.grey.A700
}));
